export const convertirTimestamp = (timestamp) => {
  // Crea un nuevo objeto Date a partir del timestamp
  const date = new Date(timestamp);

  // Extrae día, mes y año
  const day = ("0" + date.getDate()).slice(-2);
  const month = ("0" + (date.getMonth() + 1)).slice(-2); // Los meses van de 0 a 11
  const year = date.getFullYear();

  // Extrae horas y minutos
  const hours = ("0" + date.getHours()).slice(-2);
  const minutes = ("0" + date.getMinutes()).slice(-2);

  // Formato DD/MM/YYYY HH:MM
  return `${day}/${month}/${year} ${hours}:${minutes}`;
}


